export default __webpack_public_path__ + "img/acbae57f1cf5df5f139e5332dbccdbbf.png";